
<div
    class="Spinner"
    :class="[
        { 'is-small': size === 'small' },
        { 'is-medium': size === 'medium' },
        { 'is-large': size === 'large' },
    ]"
>
    <i class="ri-loader-4-line"></i>
</div>
